namespace Message {
  export const ERROR_AUTH_FAILURE =
    "認証に失敗しました。再度ログイン操作を行ってください。";
  export const ERROR_NO_USER = "ユーザー情報の取得に失敗しました";
  export const ERROR_INPUT = "入力エラーがあります";
  export const ERROR_UNEXPECTED = "予期せぬエラーが発生しました";
  export const ERROR_MAIL_SEND = "メールの送信に失敗しました";
  export const SUCCESS_MAIL_SEND = "メールを送信しました";

  export const SUCCESS_RESET_PASSWORD = "パスワードを再設定しました";
  export const ERROR_RESET_PASSWORD = "パスワードの再設定に失敗しました";

  export const CONFIRM_DAKOKU = "打刻しますか？";
  export const CONFIRM_DAKOKU_SYOUNIN_FOR_ALREADY =
    "この勤務はすでに承認／否認済みですが再度実行しますか？\n※実行した場合、以前のコメントは消え、再度お知らせが相手に届きます";
  export const CONFIRM_RECALC_DAKOKU = "打刻の再計算を実行しますか？";
  export const CONFIRM_RECALC_DAKOKU_ALL = "打刻の再計算を実行しますか？（総務修正済みの日は再計算されません）";
  export const NO_INFO_ERROR_RECALC_DAKOKU =
    "再計算に必要な情報が不足しています<br>画面更新後に再度お試しください。";

  export const DAKOKU_SYUUSEI =
    "修正が必要な場合はタイムシートより打刻修正の申請を提出して下さい";

  export const DAKOKU_SYOUNIN =
    "打刻を行いたい場合、承認者へお問い合わせください";

  export const ERROR_GET_DAKOKU = {
    DIALOG_TITLE: "打刻情報の取得に失敗しました",
    TEXT: "アプリの場合は再起動、ブラウザの場合は再読み込みをお試し下さい",
  };

  export const ALREADY_DAKOKU = {
    DIALOG_TITLE: "すでに打刻済みです",
    TEXT: DAKOKU_SYUUSEI,
  };
  export const KOUKYUU_DAKOKU =
    "公休日に打刻しようとしています。続行しますか？";

  export const DISABLED_SYUKKINU_DAKOKU_AFTER_TAIKIN = {
    DIALOG_TITLE: "退勤後の出勤打刻はできません",
    TEXT: DAKOKU_SYUUSEI,
  };

  export const DISABLED_GAISYUTSU_DAKOKU_AFTER_MODORI = {
    DIALOG_TITLE: "戻り後の外出打刻はできません",
    TEXT: DAKOKU_SYUUSEI,
  };

  export const DISABLED_GAISYUTSU_AND_MODORO_DAKOKU_AFTER_TAIKIN = {
    DIALOG_TITLE: "退勤後の外出・戻り打刻はできません",
    TEXT: DAKOKU_SYUUSEI,
  };

  export const ERROR_DAKOKU = {
    DIALOG_TITLE: "打刻に失敗しました",
    TEXT: "再度実行しても失敗する場合は、お手数ですが打刻修正申請を行ってください",
  };

  export const ERROR_PERMISSION = {
    DIALOG_TITLE: "アクセス権がありません",
    TEXT: "業務で必要な操作の場合、総務へお問い合わせください",
  };

  export const ERROR_SAVE_PERMISSIONS = {
    DIALOG_TITLE: "権限の設定に失敗しました",
  };

  export const ALREADY_DAKOKU_SYOUNIN = {
    DIALOG_TITLE: "承認済のため打刻できません",
    TEXT: DAKOKU_SYOUNIN,
  };

  export const EMPTY_OSHIRASE = "表示可能なお知らせはありません";

  export const HAS_UNCOMPLETE_DAKOKU_ERROR =
    "不完全な打刻があります。出勤と退勤、外出と戻り、それぞれが対応するよう打刻を修正してから再度実行してください。";

  export const HAS_WAIT_SHINSEI_ERROR =
    "未承認の申請があります。全ての申請を承認／否認してから再度実行してください。";
}

export default Message;
